module.exports = __webpack_public_path__ + "img/home_menu_13_selected.7b11781a.png";